/* eslint-disable no-nested-ternary */
import { isDenominationMixed } from "components/common/cassettes";

export const makeEditPayload = (
  location,

  currenciesList,
) => {
  const _payload = {
    ...location,
    cashCenterId: location.cashCenterId,
    customerId: location.customerId,
    billingCustomerId: location.billingCustomerId,
    customerName: location.customer,
    billingCustomerName: location.billingCustomerName,
    contractCode: location.contractCode,
    cashCenterName: location.cashCenter,
    category: location.category ? location.category : "",
    locationType: location.locationType ? location.locationType : "",
    status: location.status ? location.status : "",
    siteType: location.siteType ? location.siteType : "",
    state: location.state ? location.state : "",
    city: location.city ? location.city : "",
    emirate: location.emirate ? location.emirate : "",
    fixingSide: location.fixingSide ? location.fixingSide : "",
    loadingSide: location.loadingSide ? location.loadingSide : "",
    machineType: location.machineType ? location.machineType : "",
    maker: location.maker ? location.maker : "",
    model: location.model ? location.model : "",
    onwardLocations: location.onwardLocations || [],

    locationId: location.locationId || "",
    locationName: location.locationName || "",
    locationCode: location.locationCode || "",

    requestedBy: location.requestedBy || "",
    comments: location.comments || "",
    routeNo: location.routeNo || "",
    followStandardModels: location.followStandardModels || null,
    followStandardDenominations: location.followStandardDenominations || null,
    followStandardCassettes: location.followStandardCassettes || null,
    lockSerialNo: location?.lockSerialNo || "",
    machineSerialNo: location?.machineSerialNo || "",
    barcode: location?.barcode || "",
    siteLimit: location?.siteLimit || "0",
    distanceFromBase: location?.distanceFromBase || 0,
    coLocatedGroupNo: location?.coLocatedGroupNo || 0,
    numberOfCassettes: location?.numberOfCassettes || 0,
    numberOfBins: location?.numberOfBins || 0,
    numberOfKeys: location?.numberOfKeys || 0,

    // convert to boolean explicitly if needed
    requiresCashierCount: Boolean(location?.requiresCashierCount),
    requiresEVhr: Boolean(location?.requiresEVhr),
    hasSecurityAlarm: Boolean(location?.hasSecurityAlarm),
    hasCamera: location.hasCamera ? 1 : 0,

    alarmDetails: location?.alarmDetails || "",
    cameraType: location?.cameraType || "",

    country: location?.country || "",
    area: location?.area || "",
    address: location?.address || "",

    longitude: location?.longitude || 0,
    latitude: location?.latitude || 0,

    machineInstallationDate: location?.machineInstallationDate || null,
    lockInstallationDate: location?.lockInstallationDate || null,
    firstServiceDate: location?.firstServiceDate || null,
    decomissionedDate: location?.decomissionedDate || null,

    dedicatedSerials: location?.dedicatedSerials || [],
    serviceDays: location?.serviceDays || [],
    allowedDays: location?.allowedDays || [],
    siteSLAs:
      location.siteSLAs?.map((elm) => ({
        serviceType: elm.serviceType || "",
        activityType: elm.activityType || "",
        responseTime: elm.resolutionTime,
        attendedTime: elm.attendedTime,
        resolutionTime: elm.resolutionTime,
      })) || [],
    followsCustomerSla: location.followsCustomerSla || false,
    operationalWindows:
      location.operationalWindows?.map((elm) => ({
        startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
        endDateTime: elm.endDateTime ? new Date(elm.endDateTime) : null,
        cutOffTime: elm.cutOffTime ? new Date(elm.cutOffTime) : null,
      })) || [],
    serviceWindows:
      location.serviceWindows?.map((elm) => ({
        dayOfWeek: elm.dayOfWeek || "",
        startTime: elm?.startTime || null,
        endTime: elm?.endTime || null,
        secondStartTime: elm?.secondStartTime || null,
        secondEndTime: elm?.secondEndTime || null,
      })) || [],
    followsCustomerServiceWindow:
      location.followsCustomerServiceWindow || false,
    cassettes:
      location.cassettes?.map((elm) => {
        return {
          description: elm.description,
          denomination: elm.denomination,
          currency: isDenominationMixed(elm.description)
            ? ""
            : elm.denomination
              ? currenciesList.find(
                  (item) => item.shortName === elm.denomination.split(" ")[0],
                )
              : "",
          multiple: isDenominationMixed(elm.description)
            ? ""
            : elm.denomination
              ? elm.denomination.split(" ")[1]
              : "",
          cassetteType: elm.cassetteType ? elm.cassetteType : "",
          maker: elm.maker,
          limit: elm.limit,
          dualScanning: elm.dualScanning,
        };
      }) || [],
    denominations:
      location.denominations?.map((elm) => ({
        currency: elm.currency ? elm.currency : "",
        multiple: elm.multiple ? elm.multiple.toString() : "",
        shape: elm.shape ? elm.shape : "",
        version: elm.version,
      })) || [],
    replenishmentModels:
      location.replenishmentModels?.map((elm) => ({
        code: elm.code,
        denominations:
          elm.denominations?.map((item) => {
            return {
              currency: item.denomination
                ? item.denomination.split(" ")[0]
                : "",
              multiple: item.denomination
                ? item.denomination.split(" ")[1]
                : "",
              noOfCassettes: item.noOfCassettes || 0,
              noOfNotes: item.noOfNotes || 0,
            };
          }) || [],
      })) || [],
    siteRepresentatives:
      location.siteRepresentatives?.map((elm) => ({
        name: elm.name,
        employeeId: elm.employeeId,
        mobileNo: elm.mobileNo,
        email: elm.email,
      })) || [],

    serviceSchedules: location.serviceSchedules.map((elm) => ({
      scheduleType: elm.scheduleType,
      serviceType: elm.serviceType,
      jobType: elm.jobType,
      routeNo: elm.routeNo,
      weekDays: elm.weekDays,
      monthDates: elm.monthDates,
    })),
  };

  return _payload;
};

export const makePayload = (servicePoint) => {
  const _payload = {
    customerId: servicePoint.customerId || "",
    billingCustomerId: servicePoint.billingCustomerId || "",
    customer: servicePoint.customerName || "",
    billingCustomerName: servicePoint.billingCustomerName || "",
    contractCode: servicePoint.contractCode || "",
    cashCenterId: servicePoint.cashCenterId || "",
    cashCenter: servicePoint?.cashCenterName || "",
    locationId: servicePoint.locationId,
    locationName: servicePoint.locationName,
    locationCode: servicePoint.locationCode,
    category: servicePoint.category,
    routeNo: servicePoint.routeNo || "",
    locationType: servicePoint.locationType || "",
    status: servicePoint.status || "",
    siteType: servicePoint.siteType || "",
    fixingSide: servicePoint.fixingSide || "",
    loadingSide: servicePoint.loadingSide || "",
    machineType: servicePoint.machineType || "",
    maker: servicePoint.maker || "",
    model: servicePoint.model || "",
    lockSerialNo: servicePoint.lockSerialNo,
    machineSerialNo: servicePoint.machineSerialNo,
    barcode: servicePoint.barcode,
    siteLimit: `${servicePoint.siteLimit || ""}`,
    distanceFromBase: servicePoint.distanceFromBase,
    coLocatedGroupNo: servicePoint.coLocatedGroupNo,
    maximumCassettes: servicePoint.maximumCassettes,
    requiresCashierCount: servicePoint.requiresCashierCount,
    requiresEVhr: servicePoint.requiresEVhr,
    hasSecurityAlarm: servicePoint.hasSecurityAlarm,
    alarmDetails: servicePoint.alarmDetails,
    country: servicePoint.country || "",
    state: servicePoint.state || "",
    emirate: servicePoint.emirate || "",
    city: servicePoint.city || "",
    address: servicePoint.address || "",
    longitude:
      !servicePoint.longitude || servicePoint.longitude === "0"
        ? 0
        : servicePoint.longitude,
    latitude:
      !servicePoint.latitude || servicePoint.latitude === "0"
        ? 0
        : servicePoint.latitude,
    lockInstallationDate: servicePoint.lockInstallationDate,
    firstServiceDate: servicePoint.firstServiceDate,
    decomissionedDate: servicePoint.decomissionedDate,
    followStandardModels: Boolean(servicePoint.followStandardModels),
    followStandardDenominations: Boolean(
      servicePoint.followStandardDenominations,
    ),
    followStandardCassettes: Boolean(servicePoint.followStandardCassettes),
    dedicatedSerials: servicePoint.dedicatedSerials || [],
    serviceDays: servicePoint.serviceDays,
    allowedDays: servicePoint.allowedDays,
    siteSLAs:
      servicePoint.siteSLAs?.map((elm) => ({
        serviceType: elm.serviceType || "",
        activityType: elm.activityType || "",
        responseTime: Number(elm.responseTime),
        attendedTime: Number(elm.attendedTime),
        resolutionTime: Number(elm.resolutionTime),
      })) || [],
    followsCustomerSla: servicePoint.followsCustomerSla || false,
    operationalWindows:
      servicePoint.operationalWindows?.map((elm) => ({
        startDateTime: elm.startDateTime || "",
        endDateTime: elm.endDateTime || "",
        cutOffTime: elm.cutOffTime || "",
      })) || [],
    serviceWindows:
      servicePoint.serviceWindows?.map((elm) => ({
        dayOfWeek: elm.dayOfWeek || "",
        startTime: elm.startTime || "",
        endTime: elm.endTime || "",
        secondStartTime: elm.secondStartTime || null,
        secondEndTime: elm.secondEndTime || null,
      })) || [],
    followsCustomerServiceWindow:
      servicePoint.followsCustomerServiceWindow || false,
    cassettes: servicePoint.followStandardCassettes
      ? []
      : servicePoint.cassettes?.map((elm) => ({
          description: elm.description || "",
          denomination: elm.denomination,
          cassetteType: elm.cassetteType || "",
          maker: elm.maker,
          limit: elm.limit,
          dualScanning: elm.dualScanning,
        })) || [],
    denominations: servicePoint.followStandardDenominations
      ? []
      : servicePoint.denominations?.map((elm) => ({
          currency: elm.currency || "",
          multiple: elm.multiple || "",
          shape: elm.shape || "",
          version: elm.version,
        })) || [],
    replenishmentModels: servicePoint.followStandardModels
      ? []
      : servicePoint.replenishmentModels?.map((elm) => ({
          code: elm.code,
          denominations: elm.denominations.map((item) => ({
            denomination:
              item.currency && item.multiple
                ? `${item.currency} ${item.multiple}`
                : "",
            noOfCassettes: item.noOfCassettes || 0,
            noOfNotes: item.noOfNotes || 0,
          })),
        })) || [],
    siteRepresentatives:
      servicePoint.siteRepresentatives?.map((elm) => ({
        name: elm.name,
        employeeId: elm.employeeId,
        mobileNo: elm.mobileNo,
        email: elm.email,
      })) || [],
    onwardLocations: servicePoint.onwardLocations || [],

    requestedBy: servicePoint.requestedBy || "",
    comments: servicePoint.comments || "",

    numberOfCassettes: servicePoint.numberOfCassettes || 0,
    numberOfBins: servicePoint.numberOfBins || 0,
    numberOfKeys: servicePoint.numberOfKeys || 0,

    hasCamera: Boolean(servicePoint?.hasCamera) || false,

    cameraType: servicePoint.cameraType || "",

    area: servicePoint.area || "",

    machineInstallationDate: servicePoint.machineInstallationDate || new Date(),

    serviceSchedules: servicePoint.serviceSchedules.map((elm) => ({
      scheduleType: elm.scheduleType,
      serviceType: elm.serviceType,
      jobType: elm.jobType,
      routeNo: elm.routeNo,
      weekDays: elm.weekDays,
      monthDates: elm.monthDates,
    })),
  };

  return _payload;
};

export const to24HourTime = (date) => {
  if (!(date instanceof Date)) return null;
  const h = String(date.getHours()).padStart(2, "0");
  const m = String(date.getMinutes()).padStart(2, "0");
  return `${h}:${m}:00`;
};

export const from24HourTime = (value) => {
  if (!value) return null;
  const [h, m] = value.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
};
